import { Pipe, PipeTransform } from '@angular/core';
import { DateTime } from '@nts/std/types';

@Pipe({
    name: 'NTSDateTime',
    standalone: true
})
export class NTSDateTimePipe implements PipeTransform {
    transform(value: Date, showTime: boolean = false): string {
        if (!value) return '';
        return DateTime.getFormattedValue(value, showTime);
    }
}